<template>
  <div>
    <el-cascader
      ref="cascader"
      :value="value"
      :placeholder="placeholder"
      :options="options"
      :size="size"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :props="props"
      :show-all-levels="false"
      :style="vstyle"
      :class="vclass"
      style="width: 100%"
      @change="change"
    >
      <template slot-scope="{ node, data }">
        <span>{{ data.label }}</span>
        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
      </template>

      <template #empty>
        <div>{{ loading ? '加载中……' : '暂无数据' }}</div>
      </template>
    </el-cascader>
  </div>
</template>

<script>
import { request } from '@/api/service'
export default {
  name: 'category-cascader',
  props: {
    masterCategoryCode: { type: String, default: '' },
    detailCategoryCode: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'small' },
    filterable: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    props: { type: Object, default: () => ({}) },
    vstyle: { type: String, default: '' },
    vclass: { type: String, default: '' },
    params: { type: Object, default: () => ({}) },
  },
  data() {
    return { options: [], loading: false }
  },
  computed: {
    value() {
      const codes = [this.masterCategoryCode, this.detailCategoryCode]
      return Array.from(new Set(codes.filter(Boolean)))
    },
  },
  watch: {
    params() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if (this.loading) return
      this.loading = true
      const res = await request({
        url: '/master/masterCategory/tree',
        method: 'GET',
        params: this.params,
        timeout: 60000,
      }).catch(() => null)
      this.loading = false
      this.options = this._dataTransform(res?.body?.data)
      this.$emit('loaded', this.options)
    },
    _dataTransform(data) {
      if (!data?.length) return []

      return data.map((item) => {
        const { children, ...t } = item
        if (!children?.length) return { ...t }
        return { ...t, children: this._dataTransform(children) }
      })
    },
    change(value) {
      const checkedNodes = this.$refs.cascader.getCheckedNodes()
      const checkedNode = checkedNodes[0] || {}
      const pathNodes = checkedNode.pathNodes || []
      const nodes = pathNodes.map(({ value, label }) => ({ value, label }))
      const masterCategoryCode = value[0] || ''
      const categoryFullName = checkedNode.label || ''
      const detailCategoryCode = value?.length ? value[value.length - 1] : ''
      this.$emit('update:masterCategoryCode', masterCategoryCode)
      this.$emit('update:detailCategoryCode', detailCategoryCode)
      this.$emit('update:categoryFullName', categoryFullName)
      this.$nextTick(() => this.$emit('change', { value, nodes }))
    },
  },
}
</script>

<style scoped></style>
